import Splide from '@splidejs/splide';

let imageVideoSlides = document.getElementsByClassName('image-video-slider');

document.addEventListener('DOMContentLoaded', function () {
    for (let i = 0; i < imageVideoSlides.length; i++) {
        let splide = new Splide(imageVideoSlides[i], {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            rewind: true,
            pagination: false,
            arrows: true,
            width: '100%'
        });

        let bar = splide.root.querySelector('.splide-progress-bar');

        splide.on('mounted move', function () {
            let end = splide.Components.Controller.getEnd() + 1;
            bar.style.width = String(100 * (splide.index + 1) / end) + '%';
        });

        splide.on('moved', function () {
            let videosUpload = document.querySelectorAll('.image-video-slider video');
            let videosYoutube = document.querySelectorAll('.image-video-slider [data-video]');

            // Pause all uploaded videos
            videosUpload.forEach((video, index) => {
                video.pause();
            });

            // Pause all youtube videos
            videosYoutube.forEach((video, index) => {
                video.parentElement.classList.remove('play');
                video.innerHTML = '<div class="play-button"><span class="icon"></span><span class="icon-text">' + buttonTranslation + ' </span></div>';
            });
        });

        splide.mount();
    }
});

let videoElements = document.querySelectorAll('[data-video]');
videoElements.forEach(function (element) {
    element.addEventListener('click', function () {
        let parentElement = this.parentElement;
        let videoId = this.getAttribute('data-video-id');

        this.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId +
            '?rel=1&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        parentElement.classList.add('play');
    });
});
